import { AccountManagement } from "@/interfaces/accountManagement";
import accountServices from "@/services/account.services";
import find from "lodash/find";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import CreditCardsListComponent from "../AccountCreditCards/CreditCardList/CreditCardsList.component";
import Template from "./PayBillModal.template.vue";

@Component({
  mixins: [Template],
  components: {
    "cards-list": CreditCardsListComponent
  }
})
export default class PayBillModal extends Vue {
  @Getter("user", { namespace: "authModule" })
  public user!: any;
  public editing: boolean = false;
  public selectedCard: AccountManagement.CreditCard | null = null;
  public cards: AccountManagement.CreditCard[] = [];
  public loading = false;

  public done() {
    this.$emit("resolve", this.selectedCard!.id);
  }

  public selectCardAsAutoBillDefault($event: AccountManagement.CreditCard) {
    this.selectedCard = $event;
  }

  protected created() {
    this.loadCards();
  }

  protected async loadCards() {
    this.loading = true;
    this.cards = await accountServices.getCreditCards(
      this.user.settings.current_account_id
    );
    const findDef = find(this.cards, "default") as AccountManagement.CreditCard;
    this.selectedCard = findDef || null;
    this.loading = false;
  }
}
